import template from './global-search-modal.pug';
import './global-search-modal.scss';

export const GlobalSearchModalComponent = {
  template,
  bindings: {
    resolve: '<',
    modalInstance: '<',
  },
  controller: class GlobalSearchModalComponent {
    constructor(Search, $state, $async, $log) {
      'ngInject';
      this.Search = Search;
      this.$state = $state;
      this.$log = $log;

      this.searchForIt = $async(this.searchForIt.bind(this));
      this.saveSearchItem = $async(this.saveSearchItem.bind(this));

      this.searchByModule = '';
      this.loading = false;
      this.query = '';
      this.hasSearched = false;
      this.hasResults = false;
    }

    $onInit() {
      this.hasSearched = false;
      this.hasResults = false;
      this.searchForIt('');
    }

    selectModule(module) {
      this.searchByModule = module == this.searchByModule ? '' : module;
      if (this.query !== '') {
        this.searchForIt(this.query);
      }
    }

    async searchForIt(query) {
      try {
        this.loading = true;
        const resp = await this.Search.global(query, this.searchByModule);
        this.hasSearched = true;
        
        if (query == '') {
          this.results = { ...resp, ...this.Search.last() };
        } else {
          this.results = resp;
          // Select tab with most results
          if (!this.searchByModule) {
            const maxResultsModule = Object.entries(this.results)
              .reduce((max, [key, value]) => 
                value.count > max.count ? { module: key, count: value.count } : max,
                { module: '', count: 0 }
              );
            if (maxResultsModule.count > 0) {
              this.searchByModule = maxResultsModule.module;
            }
          }
        }
        
        // Check if there are any results
        this.hasResults = Object.values(this.results).some(module => module.count > 0);
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loading = false;
      }
    }

    async saveSearchItem(result, type) {
      try {
        await this.Search.saveGlobalSearchResult(result.id, type);
        this.modalInstance.close();
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close();
    }
  }
};
